import { UserContextProps } from "@/contexts/UserContext/types";
import { Sidebar } from "@/data/types/sidebar";
import {
  getRemainingFreeTrialDays,
  isUserFreeTrial,
  isUserSubscribed,
  isUserUnsubscribed,
  userHasFreeTrialActive,
} from "@/services/UserService/UserService";
import { SubscriptionStatus } from "@/types/subscription";
import { UserStatus } from "@/types/user";

export const getFreeTrialDaysRemaningContent = (
  content: Sidebar,
  userContext: UserContextProps
): string => {
  const remainingFreeTrialDays = getRemainingFreeTrialDays(userContext);
  let remainingDaysContent = "";

  switch (true) {
    case remainingFreeTrialDays > 1:
      remainingDaysContent = `${remainingFreeTrialDays} ${content.sidebarFreeTrialDaysText} ${content.sidebarFreeTrialRemainingText}`; // 2 days
      break;
    case remainingFreeTrialDays === 1:
      remainingDaysContent = `${remainingFreeTrialDays} ${content.sidebarFreeTrialDayText} ${content.sidebarFreeTrialRemainingText}`; // 1 day
      break;
    case remainingFreeTrialDays <= 0:
      remainingDaysContent = content.sidebarFreeTrialExpiredText; // Expired
      break;
    default:
  }

  return `${remainingDaysContent}`;
};

export const disabledExpiredFreeTrial = (
  isFreeTrialSite: boolean,
  userContext: UserContextProps
): boolean => {
  const isUserInFreeTrial = isUserFreeTrial(userContext);
  const isUserOnActiveTrial = userHasFreeTrialActive(userContext);
  const userHasSubscription = isUserSubscribed(userContext);
  const userHasUnsubscribed = isUserUnsubscribed(userContext);

  if (!isFreeTrialSite || userHasSubscription || userHasUnsubscribed) return false;

  if (userContext?.user?.subscription?.status === SubscriptionStatus.REGISTERED) {
    if (isUserInFreeTrial && isUserOnActiveTrial) return false;
    return true;
  }

  return true;
};

export const displayFreeTrialSection = (
  isFreeTrialSite: boolean,
  userContext: UserContextProps
): boolean => {
  if (!isFreeTrialSite || !userContext?.user?.accountId) return false;

  const { user } = userContext;
  const isUserRegistered = user.userStatus === UserStatus.REGISTERED;
  const isUserInFreeTrial = user.userStatus === UserStatus.TRIAL;

  if (isUserRegistered || isUserInFreeTrial) return true;

  return false;
};

export const handleMobileSidebarClick = (isMenuOpened: boolean, onClick?: () => void): void => {
  const bodyElement = document.querySelector("body");
  const htmlElement = document.querySelector("html");
  const dashaborLayout = document.querySelector(".layout.layout--dashboard.qrnow");

  if (!isMenuOpened) {
    onClick?.();
    bodyElement.classList.remove("overflowHidden");
    htmlElement.classList.remove("overflowHidden");
    dashaborLayout?.classList.remove("no-scroll");
  } else {
    onClick?.();
    bodyElement.classList.add("overflowHidden");
    htmlElement.classList.add("overflowHidden");
    dashaborLayout?.classList.add("no-scroll");
  }
};
